//@ts-nocheck
import { Box, SxProps, useTheme } from '@mui/material';
import logo_long from 'logo_long.png';
import { useDynamicBrand } from 'src/context/DynamicBrandContext';

//TODO this is wrong obviously
export enum LogoVariant {
  PRIMARY = `/static/images/brand/${process.env.REACT_APP_BRAND ?? 'switch'}/Logo_green_switch.svg`,
  SECONDARY = `/static/images/brand/${process.env.REACT_APP_BRAND ?? 'switch'}/Logo_green_switch.svg`,
  TERTIARY = `/static/images/brand/${process.env.REACT_APP_BRAND ?? 'switch'}/Logo_white_switch.svg`,
  MONOCHROME = 'monochrome',
  INVERTED = 'inverted',
  MINIMAL = 'minimal',
}

interface ILogoInterface {
  height?: number | string;
  width?: number | string;
  variant?: LogoVariant;
  sxProps?: SxProps;
}

function Logo(props: ILogoInterface) {
  const {
    height = 'auto',
    width = 'auto',
    variant = LogoVariant.PRIMARY,
  } = props;

  const theme = useTheme();
  const { config } = useDynamicBrand();
  const isWhitelabel =
    process.env.REACT_APP_BRAND && process.env.REACT_APP_BRAND !== 'switch';
  const logoSrc = config.logoLongUrl || (isWhitelabel ? null : logo_long);

  if (!logoSrc) return <Box sx={props.sxProps} height={height} />;

  return (
    <Box sx={props.sxProps}>
      <img src={logoSrc} alt='Logo' height={height} width={width} />
    </Box>
  );
}

export default Logo;
